import api from "@/services/api.ts";
import {RequestOverview} from "@/types/RequestOverview.ts";
import {SeasonTrendSummary} from "@/types/TrendSummary.ts";

const URL = '/suggestions';

type ResponseData = {
    status: 'success' | 'failure';
    message: string;
}

export const generateMatches = async (): Promise<ResponseData> => {
    try {
        const response = await api.get(`${URL}/generate`);
        return {
            status: 'success',
            message: response.data.msg,
        };
    } catch (error: any) {
        let errorMessage;
        if (error.response) {
            console.error("Error response:", error.response.data);
            errorMessage = error.response.data.msg;
        } else if (error.request) {
            // Request was made but no response received
            console.error("Error request:", error.request);
            errorMessage = "No response from the server.";
        } else {
            // Something happened in setting up the request
            console.error("Error message:", error.message);
            errorMessage = error.message;
        }
        return {
            status: 'failure',
            message: errorMessage,
        }
    }
}

export const getSummary = async(seasonId?: number): Promise<RequestOverview> => {
    try {
        const suffix = seasonId ? `?seasonId=${seasonId}` : "";
        const {data} = await api.get(`${URL}/summary${suffix}`);
        return data;
    } catch (error: any) {
        throw new Error('Failed to get mentorship requests overview.');
    }
}

export const backfillGapSummary = async (seasonId: number): Promise<void> => {
    await api.post(`${URL}/summary/backfill`, { seasonId });
};

export const getTrendSummary = async (): Promise<SeasonTrendSummary[]> => {
    try {
        const {data} = await api.get(`${URL}/summary/trends`);
        return data;
    } catch (error: any) {
        throw new Error('Failed to get trend summary.');
    }
}
